module.exports = __webpack_public_path__ + "static/media/owner.23c9d6bb.svg";